<template>
  <div>
    <!-- <guestMenu v-if="this.$router.history.current.path != '/login' && this.$router.history.current.path != '/cadastrar'" :logado="true" :alert="this.alert"></guestMenu> -->
    <AlertComponent :alert="this.alert"></AlertComponent>
    <component :alert="this.alert" v-bind:is="component.name"></component>
  </div>
</template>

<script>
import Menu from "@/components/menu/GuestMenu.vue";
import AlertComponent from "@/components/shared/alertMessage/AlertMessage.vue";
import AlertMessage from "@/domain/alertMessage/AlertMessage.js";
import home from "@/pages/guestArea/home/Home.vue";
import login from "@/pages/guestArea/login/Login.vue";
import cadastrar from "@/pages/guestArea/novaConta/NovaConta.vue";
import fechaMensalDownload from "@/pages/guestArea/download/fechamentoMensal/Download.vue";
export default {
  components: {
    guestMenu: Menu,
    AlertComponent: AlertComponent,
    home: home,
    login: login,
    cadastrar: cadastrar,
    fechaMensalDownload: fechaMensalDownload
  },
  data() {
    return {
      alert: new AlertMessage(),
      component: { name: "" }
    };
  },
  created: function() {},
  mounted: function() {
    // this.closeJivoChat();
    this.$nextTick(function() {
      if (
        this.$router.history.current.path == "/" ||
        this.$router.history.current.path == "/login"
      ) {
        if (this.$router.afterHooks.length > 0) {
          this.alert.snackDanger();
          this.alert.snack.text = this.$router.afterHooks[0].msg;
          this.alert.snack.show = true;
        }
        this.component.name = "login";
      } else if (this.$router.history.current.path == "/cadastrar") {
        this.component.name = "cadastrar";
      } else if (this.$router.history.current.path == "/download/fechamentoMensal") {
        this.component.name = "fechaMensalDownload";
      }
    });
  },
  watch: {
    $route: function() {
      if (
        this.$router.history.current.path == "/" ||
        this.$router.history.current.path == "/login"
      ) {
        if (this.$router.afterHooks.length > 0) {
          this.alert.snackDanger();
          this.alert.snack.text = this.$router.afterHooks[0].msg;
          this.alert.snack.show = true;
        }
        this.component.name = "login";
      } else if (this.$router.history.current.path == "/cadastrar") {
        this.component.name = "cadastrar";
      } else if (this.$router.history.current.path == "/download/fechamentoMensal") {
        this.component.name = "fechaMensalDownload";
      }
    }
  },
  computed: {},
  methods: {
    closeJivoChat() {
      const jivoChat = document.querySelector('jdiv');
      if(jivoChat) {
        // jivoChat.remove();
        jivoChat.style.display = "none";
      }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component.name only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  text-decoration: none;
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/pages/guestArea/GuestArea.vue